import type { Theme } from '@mui/material';
import type { PreCleanRatingType } from '../models';

/**
 * Define color based on PreClean rating value
 * @param rating
 * @param theme
 */
export const defineRatingColor = (rating: PreCleanRatingType | null, theme: Theme): string => {
  switch (rating) {
    case 'A':
      return theme.colors.avani.aDarkPink;
    case 'B':
      return theme.colors.avani.aPurple;
    case 'C':
      return theme.colors.avani.aGreen;
    case 'D':
      return theme.colors.avani.aYellow;
    default:
      return theme.colors.avani.aGrey;
  }
};

/**
 * Define color based on Trend rating value
 * @param type
 * @param rating
 * @param theme
 */
export const defineColorFromTrendRating = (type: 'preClean' | 'temp', rating: number | null, theme: Theme) => {
  switch (rating) {
    case 1:
      return type === 'preClean' ? theme.colors.avani.turc : theme.colors.avani.aHot;
    case -1:
      return type === 'preClean' ? theme.colors.avani.magenta : theme.colors.avani.aCold;
    default:
      return theme.colors.avani.teal;
  }
};

export const defineTempRangeLabel = (min: number | null | undefined, max: number | null | undefined) => {
  if (!min && min !== 0 && !max && max !== 0) return '-';
  if (min === null) return `< ${max}°C`;
  if (max === null) return `> ${min}°C`;
  return `${min}°C <> ${max}°C`;
};

export const handleTempLabel = (temp: number | null | undefined) => {
  if (temp === null || temp === undefined) return `-`;
  return `${temp}°C`;
};

export const extractHygieneColors = (hygieneStatus: boolean | null, theme: Theme): { color: string; bg: string } => {
  switch (hygieneStatus) {
    case null:
      return { color: 'rgba(30, 30, 30, 0.6)', bg: 'rgba(30, 30, 30, 0.3)' };
    case true:
      return { color: theme.colors.avani.turc, bg: 'rgba(0,167,168, 0.4)' };
    case false:
      return { color: theme.colors.avani.magenta, bg: 'rgba(230,0,126, 0.4)' };
  }
};
